/**
 * Normalise the vanity id claim in the access token.
 *
 * There's an unusual issue in the Identity data where a few thousand users
 * have multiple vanity ID claims. Here just pick one (the sort being to
 * make it deterministic).
 */
const normaliseVanityId = (vanityId: string | Array<string>) => {
  if (Array.isArray(vanityId)) {
    return vanityId.sort()[0];
  }

  return vanityId;
};

export default normaliseVanityId;
